"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.stockFormEmail = exports.schemafy = exports.schemaRules = exports.schemaLabels = exports.schemaItem = exports.schemaInitialValues = exports.schemaFields = exports.relabel = exports.formSchemaValidator = exports.domOnlyProps = exports.Warning = void 0;
exports.submitForm = submitForm;
exports.warnForm = exports.warn = exports.textifyFields = exports.tableifyFields = void 0;
var _jsx2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/jsx"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var Joi = _interopRequireWildcard(require("joi"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sanitization = require("@raywhite/helpers-utils/lib/helpers/sanitization");
var _link = require("@raywhite/helpers-utils/lib/helpers/link");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line no-unused-vars

/**
 * Returns a validator for the schema, suitable for using with redux-form.
 *
 * @param {Array} fields A list of the form fields.
 * @param {Joi} schema A Joi schmea to apply.
 *
 * @return {Function} A function which validates form values, it takes the values
 * and returns an object containing errors keyed by field name, if any.
 *
 * TODO: Should pass back values as well (filtering may change them)
 */
var formSchemaValidator = (fields, schema) => {
  var template = (0, _reduce.default)(fields).call(fields, (result, field) => {
    result[field] = '';
    return result;
  }, {});
  return values => {
    var _context;
    var {
      error
    } = Joi.validate({
      ...template,
      ...values
    }, schema);
    if (!error) {
      return {};
    }
    return (0, _reduce.default)(_context = error.details).call(_context, (errors, e) => {
      var {
        context,
        message,
        path,
        type
      } = e;
      var field = path === 'value' ? context.peers[0] : path;

      // Always overwrite existing messages with any.empty
      if (type === 'any.empty') {
        errors[field] = message;
        return errors;
      }
      if (errors[field]) {
        return errors;
      }
      errors[field] = message;
      return errors;
    }, {});
  };
};
exports.formSchemaValidator = formSchemaValidator;
var Warning = _ref => {
  var {
    children,
    htmlFor
  } = _ref;
  return (
    /*#__PURE__*/
    // Note: this is fine, we specify htmlFor, not sure why eslint complains
    (0, _jsx2.default)("label", {
      htmlFor: htmlFor,
      className: "error"
    }, void 0, children)
  );
};
exports.Warning = Warning;
var warn = _ref2 => {
  var {
    error,
    name,
    touched
  } = _ref2;
  return error && touched ? /*#__PURE__*/(0, _jsx2.default)(Warning, {
    htmlFor: name
  }, void 0, error) : undefined;
};
exports.warn = warn;
var warnForm = error => error && /*#__PURE__*/(0, _jsx2.default)("div", {
  className: "form_notice error"
}, error, error);

// TODO: remove once upgraded to redux-form v6, which makes this redundant
exports.warnForm = warnForm;
var domOnlyProps = _ref3 => {
  var {
    active,
    autofill,
    autofilled,
    dirty,
    error,
    initialValue,
    invalid,
    onUpdate,
    pristine,
    touched,
    valid,
    visited,
    ...domProps
  } = _ref3;
  return domProps;
};
exports.domOnlyProps = domOnlyProps;
function submitForm(fetch, dataLayer, type, endpoint, data) {
  var errorMessage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'Unable to send form';
  var label = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
  var method = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'POST';
  var request = fetch(endpoint, {
    method,
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json'
    },
    body: (0, _stringify.default)(data)
  });
  return request.then(r => r.json()).then(response => {
    (0, _link.formEvent)(dataLayer, endpoint, type, data, response, label);
    return response;
  }).catch(() => {
    var error = new Error();
    error._error = errorMessage;
    return _promise.default.reject(error);
  }).then(r => {
    if (r.error) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return _promise.default.reject({
        _error: r.message,
        ...(r.error || {})
      });
    }
    return r;
  });
}
var relabel = (keys, labels, values) => (0, _reduce.default)(keys).call(keys, (labelled, key) => {
  if (values[key] === undefined) {
    return labelled;
  }
  labelled.push({
    key,
    label: labels[key],
    value: values[key]
  });
  return labelled;
}, []);
exports.relabel = relabel;
var textifyFields = function (data) {
  var clean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _map.default)(data).call(data, _ref4 => {
    var _context2;
    var {
      label,
      value
    } = _ref4;
    return (0, _concat.default)(_context2 = "".concat(label, ": ")).call(_context2, clean ? (0, _sanitization.cleanInput)(value) : value);
  }).join('\r\n');
};
exports.textifyFields = textifyFields;
var tableifyFields = data => {
  var _context3, _context4;
  return (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = ['<table><tbody>']).call(_context4, (0, _map.default)(data).call(data, _ref5 => {
    var _context5;
    var {
      label,
      value
    } = _ref5;
    return (0, _concat.default)(_context5 = "<tr><th scope=\"col\">".concat(label, "</th><td>")).call(_context5, (0, _sanitization.cleanInput)(value).replace(/\n/g, '<br>'), "</td></tr>");
  }))).call(_context3, ['</tbody></table>']).join('');
};
exports.tableifyFields = tableifyFields;
var stockFormEmail = function (send, subject, fields, labels, values) {
  var _context6, _context7, _context8;
  var {
    prefix,
    referrer,
    suffix
  } = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var labelled = relabel(fields, labels, values);
  var text = textifyFields(labelled);
  var html = tableifyFields(labelled);
  var ref = referrer && (0, _indexOf.default)(prefix).call(prefix, referrer) === -1 ? "Sent from ".concat(referrer, ".") : undefined;
  return send(subject, (0, _filter.default)(_context6 = [prefix, ref, text, suffix]).call(_context6, Boolean).join('\r\n'), (0, _map.default)(_context7 = (0, _filter.default)(_context8 = [prefix, ref, html, suffix]).call(_context8, Boolean)).call(_context7, frag => "<div>".concat(frag, "</div>")).join(''), {
    replyToName: values.name,
    replyToAddress: values.email
  });
};
exports.stockFormEmail = stockFormEmail;
var schemaItem = function (key, label, rule) {
  var initialValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var labelledRule = rule && rule.label(label);
  return {
    key,
    label,
    rule: labelledRule,
    initialValue
  };
};
exports.schemaItem = schemaItem;
var reduceSchema = (schema, key) => (0, _reduce.default)(schema).call(schema, (result, field) => {
  if (field[key] === undefined) {
    return result;
  }
  result[field.key] = field[key];
  return result;
}, {});
var schemafy = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
exports.schemafy = schemafy;
var schemaFields = schema => (0, _map.default)(schema).call(schema, field => field.key);
exports.schemaFields = schemaFields;
var schemaLabels = schema => reduceSchema(schema, 'label');
exports.schemaLabels = schemaLabels;
var schemaRules = schema => {
  var _context9;
  return (0, _keys.default)(_context9 = Joi.object()).call(_context9, reduceSchema(schema, 'rule')).options({
    abortEarly: false
  });
};
exports.schemaRules = schemaRules;
var schemaInitialValues = schema => reduceSchema(schema, 'initialValue');
exports.schemaInitialValues = schemaInitialValues;